import { fetchApi } from "containers/helpers";

export const updateContractPricesAPI = (contractId, price) => fetchApi('/contract/prices/' + contractId, {
    method: 'PATCH',
    body: {
        price
    }
})